import { ColumnDef } from "@tanstack/react-table";
import { OaSchema } from "../data/schema";
import Actions from "./Actions";
import { DataTableColumnHeader } from "./data-table-column-header";
import { Badge } from "src/shadcn/components/ui";
import { convertToCamelCase } from "src/helpers";

export const columns: ColumnDef<OaSchema>[] = [
  {
    accessorKey: "srNo",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Sr.No. (#)" />,
  },
  {
    accessorKey: "start_date",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Date" />,
    cell({
      row: {
        original: { start_date, end_date },
      },
    }) {
      return (
        <>
          {start_date ? start_date : "-"} - {end_date ? end_date : "-"}
        </>
      );
    },
  },

  {
    accessorKey: "total_pages",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Total Pages" />,
  },
  {
    accessorKey: "processed_pages",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Processed Pages" />,
  },
  // {
  //   accessorKey: "upload_type",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Upload Type" />
  //   ),
  //     cell({ row: { original: { upload_type } } }) {
  //     return <>{convertToCamelCase(upload_type)}</>
  //   },

  // },

  {
    accessorKey: "status",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Status" />,
    cell({
      row: {
        original: { status },
      },
    }) {
      const statusStyles: any = {
        pending: "bg-yellow-100 text-yellow-800 hover:bg-yellow-100 hover:text-yellow-800",
        processing: "bg-blue-100 text-blue-800 hover:bg-blue-100 hover:text-blue-800",
        failed: "bg-red-100 text-red-800 hover:bg-red-100 hover:text-red-800",
        completed: "bg-green-100 text-green-800 hover:bg-green-100 hover:text-green-800",
      };

      return <Badge className={statusStyles[status]}>{convertToCamelCase(status)}</Badge>;
    },
  },

  {
    id: "Actions",
    header: ({ column }) => <DataTableColumnHeader column={column} title="View Details" />,
    cell({ row: { original } }) {
      return <Actions row={original} />;
    },
  },
];
